import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const StockSupplyInvOrgLayout = () => {
  const navList = useNav();
  let { StockSupplyOrgBottom, StockSupplyTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={StockSupplyOrgBottom} topTabs={StockSupplyTopHeader} />
      <Outlet />
    </div>
  )
}

export default StockSupplyInvOrgLayout
